export type SlideCarouselThumbnailCornerMode = 'top' | 'full';
export type SlideCarouselMetadataVisibilityStrategy = 'always' | 'hover-when-dense';

export interface SlideCarouselPresentation {
  thumbnailCornerMode: SlideCarouselThumbnailCornerMode;
  metadataVisibilityStrategy: SlideCarouselMetadataVisibilityStrategy;
  showZoomIndicator: boolean;
}

export const defaultSlideCarouselPresentation: SlideCarouselPresentation = {
  thumbnailCornerMode: 'top',
  metadataVisibilityStrategy: 'always',
  showZoomIndicator: false,
};

export const previewSlideCarouselPresentation: SlideCarouselPresentation = {
  thumbnailCornerMode: 'full',
  metadataVisibilityStrategy: 'hover-when-dense',
  showZoomIndicator: true,
};
